import {postMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/schedulerGroupsPresence', request)
}

export {post}
